import { HQ, SUBSIDIARY } from '../../../constants/commonText.constants';

export const COMPANYPROFILEINITIAL = {
	companyName: '',
	address: '',
	country: '',
	businessNo: '',
	companyType: '',
	industrySector: '',
};

export const COMPANY_TYPE_OPTIONS = [
	{ key: 'Listed', value: 'Listed' },
	{ key: 'subsidiary_related_to', value: 'Subsidiary/related to' },
	{ key: 'Non_listed', value: 'Non-listed' },
];

export const ORGSETTING = [
	{ key: 'equity_share', value: 'Equity Share' },
	{ key: 'operational_control', value: 'Operational Control' },
	{ key: 'financial_control', value: 'Financial Control' },
];

export const GHG_REPORTING_INITIAL = {
	// temperature: "",
	// targetReduction: "",
	// baseYear: "",
	// targetYear: "",
	noOfEmployees: '',
	spaceUsed: '',
	contractCapacity: '',
	annualRevenue: '',
	scope1: '',
	scope2: '',
	scope3: '',
	reportingYear: '',
	orgSetting: '',
};

export const EIDR_TABLE_DATA = [
	{ key: 'ghgInventory', value: 'GHG Inventory' },
	{ key: 'iso14064', value: 'ISO 14064 Greenhouse Gas Inventory Report' },
	{ key: 'iso14001', value: 'ISO 14001 Environmental Management System' },
	{ key: 'iso14067', value: 'ISO 14067 Product Carbon Footprint' },
	{ key: 'iso50001', value: 'ISO 50001 Energy Management System' },
	{ key: 'iso9001', value: 'ISO 9001 Quality Management System' },
	{ key: 'CBAM', value: 'CBAM (EU Carbon Border Adjustment Mechanism)' },
	{ key: 'EPD', value: 'EPD (Environmental Product Declaration)' },
	{ key: 'sustainabilityReport', value: 'Sustainability Report' },
];

export const IPB_INITIAL = {
	companyName: '',
	sustainabilityRating: '',
	envRating: '',
	UNRating: '',
	scope1: '',
	scope2: '',
	scope3: '',
	perEmployee: '',
	perRevenue: '',
	sbti: '',
	netZero: '',
};

export const SBTI_INITIAL = {
	isSBTI: null,
	sbtiTemperature: '',
	baseYear: '',
	targetYear: '',
	targetType: '',
	regressionModel: '',
	targetReduction: '',
	reductionScopes: {
		scope1: {
			isSelect: false,
			baseline: null,
		},
		scope2: {
			isSelect: false,
			baseline: null,
		},
		scope3: {
			isSelect: false,
			baseline: null,
		},
	},
};

export const EIDR_INITIAL = {
	ghgInventory: { isCompleted: null, isVerify: null },
	iso14064: { isCompleted: null, isVerify: null },
	iso14001: { isCompleted: null, isVerify: null },
	iso14067: { isCompleted: null, isVerify: null },
	iso50001: { isCompleted: null, isVerify: null },
	iso9001: { isCompleted: null, isVerify: null },
	CBAM: { isCompleted: null, isVerify: null },
	EPD: { isCompleted: null, isVerify: null },
	sustainabilityReport: { isCompleted: null, isVerify: null },
};

export const HQ_INITIAL = {
	companyName: '',
	country: '',
	address: '',
	cLevel: HQ,
};
export const SUBSIDIARY_INITIAL = {
	companyName: '',
	country: '',
	address: '',
	cLevel: SUBSIDIARY,
};

export const SBTi_TEMP = [
	{ key: 1.5, value: '1.50°C' },
	{ key: 2, value: '2.0°C' },
];

export const SBTi_TARGET_TYPE = [
	{ key: 'absolute', value: 'Absolute' },
	{ key: 'intensity', value: 'Intensity' },
];

export const SBTi_REGRESSION_MODEL = [
	{
		key: 'ghg_15',
		value: 'GHG (Kyoto Gases): Y = -0.31X + 2.70 (R² = 0.83) (targets < 15 y)',
		type: 'absolute',
	},
	{
		key: 'ghg_30',
		value: 'GHG (Kyoto Gases): Y = -0.48X + 2.84 (R² = 0.93) (targets < 30 y)',
		type: 'absolute',
	},
	{
		key: 'co2_15',
		value: 'CO₂ (Energy and Industrial Processes): Y = -0.31X + 2.62 (R² = 0.85) (targets < 15 y)',
		type: 'absolute',
	},
	{
		key: 'co2_30',
		value: 'CO₂ (Energy and Industrial Processes): Y = 0.44X + 2.72 (R² = 0.9) (targets < 30 y)',
		type: 'absolute',
	},

	{
		key: 'ghg_gdp_15',
		value: 'GHG/GDP: Y = -0.53X + 4.11 (R² = 0.83) (targets < 15 y)',
		type: 'intensity',
	},
	{
		key: 'ghg_gdp_30',
		value: 'GHG/GDP: Y = -1.1X + 4.93 (R² = 0.9) (targets < 30 y)',
		type: 'intensity',
	},
	{
		key: 'co2_mwh_15',
		value: 'CO₂/MWh (Electricity generation): Y = -0.33X + 3.33 (R² = 0.71) (targets < 15 y)',
		type: 'intensity',
	},
	{
		key: 'co2_mwh_30',
		value: 'CO₂/MWh (Electricity generation): Y = -0.78X + 3.9 (R² = 0.89) (targets < 30 y)',
		type: 'intensity',
	},
	{
		key: 'co2_pe_15',
		value: 'CO₂/PE (Primary energy): Y = -0.51X + 3.0 (R² = 0.75) (targets < 15 y)',
		type: 'intensity',
	},
	{
		key: 'co2_pe_30',
		value: 'CO₂/PE (Primary energy): Y = 0.66X + 3.21 (R² = 0.84) (targets < 30 y)',
		type: 'intensity',
	},
];

export const INDUSTRIAL_CLASSIFICATION = [
	{ key: 'food_081', value: 'Food - 081 Processing and Preserving of Meat' },
	{
		key: 'food_082',
		value: 'Food - 082 Processing and Preserving of Fish, Crustaceans and Molluscs',
	},
	{
		key: 'food_083',
		value: 'Food - 083 Processing and Preserving of Fruit and Vegetables',
	},
	{
		key: 'food_084',
		value: 'Food - 084 Manufacture of Edible Vegetable and Animal Oils and Fats',
	},
	{ key: 'food_085', value: 'Food - 085 Manufacture of Dairy Products' },
	{
		key: 'food_086',
		value: 'Food - 086 Grain Husking, Manufacture of Grain Mill Products, Starches and Starch Products',
	},
	{ key: 'food_087', value: 'Food - 087 Manufacture of Prepared Animal Feeds' },
	{ key: 'food_089', value: 'Food - 089 Manufacture of Other Food Products' },
	{
		key: 'beverages_091',
		value: 'Beverages - 091 Manufacture of Alcoholic Beverages',
	},
	{
		key: 'beverages_092',
		value: 'Beverages - 092 Manufacture of Non-alcoholic Beverages',
	},
	{
		key: 'tobacco_100',
		value: 'Tobacco - 100 Manufacture of Tobacco Products',
	},
	{
		key: 'apparel_textiles_111',
		value: 'Apparel & Textiles - 111 Spinning of Yarn',
	},
	{
		key: 'apparel_textiles_112',
		value: 'Apparel & Textiles - 112 Weaving of Textiles',
	},
	{
		key: 'apparel_textiles_113',
		value: 'Apparel & Textiles - 113 Manufacture of Non-woven Fabrics',
	},
	{
		key: 'apparel_textiles_114',
		value: 'Apparel & Textiles - 114 Finishing of Textiles',
	},
	{
		key: 'apparel_textiles_115',
		value: 'Apparel & Textiles - 115 Manufacture of Textile Products',
	},
	{
		key: 'apparel_textiles_121',
		value: 'Apparel & Textiles - 121 Manufacture of Wearing Apparel',
	},
	{
		key: 'apparel_textiles_123',
		value: 'Apparel & Textiles - 123 Manufacture of Clothing Accessories',
	},
	{
		key: 'consumer_goods_retail_130',
		value: 'Consumer Goods Retail - 130 Manufacture of Leather, Fur and Related Products',
	},
	{
		key: 'forestry_paper_140',
		value: 'Forestry & Paper - 140 Manufacture of Wood and of Products of Wood and Bamboo',
	},
	{
		key: 'forestry_paper_151',
		value: 'Forestry & Paper - 151 Manufacture of Pulp, Paper and Paperboard',
	},
	{
		key: 'forestry_paper_152',
		value: 'Forestry & Paper - 152 Manufacture of Containers of Paper and Paperboard',
	},
	{
		key: 'forestry_paper_159',
		value: 'Forestry & Paper - 159 Manufacture of Other Paper Products',
	},
	{
		key: 'media_160',
		value: 'Media - 160 Printing and Reproduction of Recorded Media',
	},
	{
		key: 'oil_gas_170',
		value: 'Oil & Gas - 170 Manufacture of Petroleum and Coal Products',
	},
	{
		key: 'chemicals_181',
		value: 'Chemicals - 181 Manufacture of Raw Chemical Material',
	},
	{
		key: 'chemicals_183',
		value: 'Chemicals - 183 Manufacture of Fertilizers and Nitrogen Compounds',
	},
	{
		key: 'chemicals_184',
		value: 'Chemicals - 184 Manufacture of Plastic and Synthetic Rubber Materials',
	},
	{
		key: 'chemicals_185',
		value: 'Chemicals - 185 Manufacture of Man-made Fibers',
	},
	{
		key: 'chemicals_191',
		value: 'Chemicals - 191 Manufacture of Pesticides and Environmental Agents',
	},
	{
		key: 'chemicals_192',
		value: 'Chemicals - 192 Manufacture of Coatings, Dyes and Pigments',
	},
	{
		key: 'chemicals_193',
		value: 'Chemicals - 193 Manufacture of Cleaning Preparations',
	},
	{
		key: 'consumer_discretionary_products_194',
		value: 'Consumer Discretionary Products - 194 Manufacture of Cosmetics',
	},
	{
		key: 'chemicals_199',
		value: 'Chemicals - 199 Manufacture of Other Chemical Products Not Elsewhere Classified',
	},
	{
		key: 'biotechnology_pharma_200',
		value: 'Biotechnology & Pharma - 200 Manufacture of Pharmaceuticals and Medicinal Chemical Products',
	},
	{
		key: 'industrial_210',
		value: 'Industrial - 210 Manufacture of Rubber Products',
	},
	{
		key: 'industrial_220',
		value: 'Industrial - 220 Manufacture of Plastics Products',
	},
	{
		key: 'construction_materials_231',
		value: 'Construction Materials - 231 Manufacture of Glass and Glass Products',
	},
	{
		key: 'construction_materials_232',
		value:
			'Construction Materials - 232 Manufacture of Refractory Products, Clay Building Materials and Other Porcelain and Ceramic Products',
	},
	{
		key: 'construction_materials_233',
		value: 'Construction Materials - 233 Manufacture of Cement and Cement Products',
	},
	{
		key: 'construction_materials_234',
		value: 'Construction Materials - 234 Cutting, Shaping and Finishing of Stone',
	},
	{
		key: 'construction_materials_239',
		value: 'Construction Materials - 239 Manufacture of Other Non-metallic Mineral Products',
	},
	{
		key: 'metals_mining_241',
		value: 'Metals & Mining - 241 Manufacture of Basic Iron and Steel',
	},
	{
		key: 'metals_mining_242',
		value: 'Metals & Mining - 242 Manufacture of Aluminum',
	},
	{
		key: 'metals_mining_243',
		value: 'Metals & Mining - 243 Manufacture of Copper',
	},
	{
		key: 'metals_mining_249',
		value: 'Metals & Mining - 249 Manufacture of Other Basic Metals',
	},
	{
		key: 'industrial_251',
		value: 'Industrial - 251 Manufacture of Cutlery, Metal Hand Tools and Die',
	},
	{
		key: 'industrial_252',
		value: 'Industrial - 252 Manufacture of Metal Structure and Architectural Components',
	},
	{
		key: 'industrial_253',
		value: 'Industrial - 253 Manufacture of Metal Containers',
	},
	{ key: 'industrial_254', value: 'Industrial - 254 Metalworking Activities' },
	{
		key: 'industrial_259',
		value: 'Industrial - 259 Manufacture of Other Fabricated Metal Products',
	},
	{ key: 'semicon_261', value: 'Semicon - 261 Manufacture of Semi-conductors' },
	{
		key: 'semicon_262',
		value: 'Semicon - 262 Manufacture of Electronic Passive Devices',
	},
	{
		key: 'semicon_263',
		value: 'Semicon - 263 Manufacture of Bare Printed Circuit Boards',
	},
	{
		key: 'semicon_264',
		value: 'Semicon - 264 Manufacture of Optoelectronic Materials and Components',
	},
	{
		key: 'semicon_269',
		value: 'Semicon - 269 Manufacture of Other Electronic Parts and Components',
	},
	{
		key: 'technology_271',
		value: 'Technology - 271 Manufacture of Computers and Peripheral Equipment',
	},
	{
		key: 'technology_272',
		value: 'Technology - 272 Manufacture of Communication Equipment',
	},
	{
		key: 'technology_273',
		value: 'Technology - 273 Manufacture of Audio and Video Equipment',
	},
	{
		key: 'technology_274',
		value: 'Technology - 274 Manufacture of Magnetic and Optical Media',
	},
	{
		key: 'technology_275',
		value: 'Technology - 275 Manufacture of Measuring, Navigating, Control Equipment, Watches and Clocks',
	},
	{
		key: 'technology_276',
		value: 'Technology - 276 Manufacture of Irradiation and Electromedical Equipment',
	},
	{
		key: 'technology_277',
		value: 'Technology - 277 Manufacture of Optical Instruments and Equipment',
	},
	{
		key: 'industrial_281',
		value: 'Industrial - 281 Manufacture of Power Generation, Transmission and Distribution Machinery',
	},
	{
		key: 'industrial_282',
		value: 'Industrial - 282 Manufacture of Batteries and Accumulators',
	},
	{
		key: 'industrial_283',
		value: 'Industrial - 283 Manufacture of Wiring and Wiring Devices',
	},
	{
		key: 'industrial_284',
		value: 'Industrial - 284 Manufacture of Lighting Equipment',
	},
	{
		key: 'consumer_goods_retail_285',
		value: 'Consumer Goods Retail - 285 Manufacture of Domestic Appliances',
	},
	{
		key: 'industrial_289',
		value: 'Industrial - 289 Manufacture of Other Electrical Equipment',
	},
	{
		key: 'industrial_291',
		value: 'Industrial - 291 Manufacture of Metalworking Machinery',
	},
	{
		key: 'industrial_292',
		value: 'Industrial - 292 Manufacture of Other Special-purpose Machinery',
	},
	{
		key: 'industrial_293',
		value: 'Industrial - 293 Manufacture of General-purpose Machinery',
	},
	{
		key: 'automobiles_301',
		value: 'Automobiles - 301 Manufacture of Motor Vehicles',
	},
	{
		key: 'automobiles_302',
		value: 'Automobiles - 302 Manufacture of Bodies (Coachwork) for Motor Vehicles',
	},
	{
		key: 'automobiles_303',
		value: 'Automobiles - 303 Manufacture of Parts for Motor Vehicles',
	},
	{
		key: 'marine_transportation_311',
		value: 'Marine Transportation - 311 Manufacture of Ships, Boats and Floating Structures',
	},
	{
		key: 'land_transportation_312',
		value: 'Land Transportation - 312 Manufacture of Motorcycles and Parts',
	},
	{
		key: 'land_transportation_313',
		value: 'Land Transportation - 313 Manufacture of Bicycles and Parts',
	},
	{
		key: 'industrial_319',
		value: 'Industrial - 319 Manufacture of Other Transport Equipment and Parts Not Elsewhere Classified',
	},
	{
		key: 'consumer_discretionary_products_321',
		value: 'Consumer Discretionary Products - 321 Manufacture of Non-metallic Furniture',
	},
	{
		key: 'consumer_discretionary_products_322',
		value: 'Consumer Discretionary Products - 322 Manufacture of Metallic Furniture',
	},
	{
		key: 'consumer_discretionary_products_331',
		value: 'Consumer Discretionary Products - 331 Manufacture of Sports and Recreational Goods',
	},
	{
		key: 'health_care_provider_332',
		value: 'Health Care Provider - 332 Manufacture of Medical Instruments and Supplies',
	},
	{
		key: 'consumer_discretionary_products_339',
		value: 'Consumer Discretionary Products - 339 Manufacturing Not Elsewhere Classified',
	},
	{ key: 'air_transportation', value: 'Air Transportation' },
	{ key: 'alternative_energy', value: 'Alternative Energy' },
	{ key: 'capital_market', value: 'Capital Market' },
	{ key: 'coal', value: 'Coal' },
	{ key: 'consumer_services', value: 'Consumer Services' },
	{ key: 'corporate_retail_banking', value: 'Corporate & Retail Banking' },
	{ key: 'food_beverage_retail', value: 'Food & Beverage Retail' },
	{ key: 'health_care_retail', value: 'Health Care Retail' },
	{ key: 'hospitality_recreation', value: 'Hospitality & Recreation' },
	{ key: 'infrastructure', value: 'Infrastructure' },
	{ key: 'internet_media_services', value: 'Internet Media & Services' },
	{ key: 'media_technology', value: 'Media Technology' },
	{ key: 'real_estate', value: 'Real Estate' },
	{ key: 'restaurants', value: 'Restaurants' },
	{ key: 'telecommunications', value: 'Telecommunications' },
	{ key: 'utilities', value: 'Utilities' },
	{ key: 'waste_management', value: 'Waste Management' },
	{ key: 'others', value: 'Others' },
];
